var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "permission",
              rawName: "v-permission",
              value: "form_protocol_query.history",
              expression: "'form_protocol_query.history'"
            },
            {
              name: "ripple",
              rawName: "v-ripple.400",
              value: "rgba(113, 102, 240, 0.15)",
              expression: "'rgba(113, 102, 240, 0.15)'",
              modifiers: { "400": true }
            },
            {
              name: "b-modal",
              rawName: "v-b-modal.modal-protocol-query-history",
              modifiers: { "modal-protocol-query-history": true }
            }
          ],
          staticClass: "waves-effect",
          attrs: { variant: "outline-warning" },
          on: { click: _vm.getListHistory }
        },
        [_vm._v(" " + _vm._s(_vm.$t("protocol_query.history")) + " ")]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-protocol-query-history",
            "cancel-variant": "outline-secondary",
            "hide-footer": "true",
            scrollable: "",
            size: "xl",
            title: _vm.$t("protocol_query.history")
          }
        },
        [
          _c("b-table", {
            attrs: {
              hover: "",
              "caption-top": "",
              responsive: "sm",
              "table-variant": "warning",
              items: _vm.listItems,
              fields: _vm.fieldsTable
            },
            scopedSlots: _vm._u([
              {
                key: "cell(created_at)",
                fn: function(ref) {
                  var created_at = ref.item.created_at
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.formatDate(created_at)))])
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }